









































import { Component, Vue, Prop } from "vue-property-decorator";
import { buildCalendar } from "../calendar/calendar";
@Component
export default class ShakenCalendar extends Vue {
  month: number = 0;
  year: number = 0;
  @Prop() labelText: string;
  dayName: string[] = ["日", "月", "火", "水", "木", "金", "土"];
  selectedDate: number = 1;

  created() {
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth();
    this.selectedDate = new Date().getDate();
  }

  get calendar() {
    let startDate = new Date(this.year, this.month, 1);
    return buildCalendar(startDate);
  }

  isSelected(date: number) {
    return date == this.selectedDate;
  }

  selectDate(date: number) {
    this.selectedDate = date;
  }

  signClass(date: number) {
    let sign = Math.floor(Math.random() * 3) + 1;
    if (sign == 2) {
      return "cross";
    } else if (sign == 3) {
      return "triangle";
    }
    return "circle";
  }

  nextMonth() {
    this.selectedDate = 1;
    if (this.month < 11) {
      this.month++;
    } else {
      this.year++;
      this.month = 0;
    }
  }

  prevMonth() {
    this.selectedDate = 1;
    if (this.month > 0) {
      this.month--;
    } else {
      this.year--;
      this.month = 12;
    }
  }
}
